<template>
  <div class="container">
    <router-view></router-view>

    <md-field>
      <span class="md-prefix">https://</span>
      <label>Api</label>
      <md-input v-model="api.endpointBase"></md-input>
    </md-field>
    <md-field>
      <label for="access_token">Access Token</label>
      <md-textarea v-model="api.accessToken" id="access_token"></md-textarea>
    </md-field>

    <md-radio v-model="env" value="remote" @change="setConfRemote()">Remote</md-radio>
    <md-radio v-model="env" value="local" @change="setConfLocal()">Local</md-radio>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "index",
  data: () => ({
    env: "remote"
  }),
  computed: {
    ...mapState("devTools", ["api"]),
    ...mapState("auth", ["user"]),
  },
  mounted() {
    this.setConfRemote()
  },
  methods: {
    setConfRemote() {
      this.api.endpointBase = "https://www.redgirasol.com/api";
      this.api.accessToken = "";
    },
    setConfLocal() {
      this.api.endpointBase = "http://localhost/api";
      this.api.accessToken = this.user.access_token;
    }
  }
}
</script>

<style scoped>

</style>
